<template>
	<div class="container">
		<el-container>
			<el-header class="header">
				<headers />
			</el-header>
			<el-container>
				<slider />
				<el-main>
					<div class="main_box">
						<div class="main_main">
							<!-- Page Header -->
							<div class="page_header">
								Add/Edit CAPA Supplier
							</div>

							<div class="page_main">
								<div class="training-type-page">
									<el-form
										ref="form"
										:model="form"
										:rules="rules"
										label-position="top"
										class="training-form"
									>
										<!-- Information Section 1 -->
										<div class="info-box">
											<div class="info-text">
												Please enter the supplier's official (unique) ID and description.
											</div>
										</div>

										<!-- Supplier Name/ID -->
										<el-form-item label="Supplier Name/ID" prop="title">
											<el-input
												v-model="form.title"
												placeholder="Please enter"
												maxlength=""
												clearable
											/>
										</el-form-item>

										<!-- Supplier Description -->
										<el-form-item label="Supplier Description" prop="description">
											<el-input
												v-model="form.description"
												placeholder="Please enter"
												maxlength=""
												clearable
											/>
										</el-form-item>

										<!-- Information Section 2 -->
										<div class="info-box">
											<div class="info-text">
												Please enter the supplier's contact information.
											</div>
										</div>

										<!-- Contact Name -->
										<el-form-item label="Contact Name" prop="name">
											<el-input
												v-model="form.name"
												placeholder="Please enter"
												maxlength=""
												clearable
											/>
										</el-form-item>

										<!-- Email -->
										<el-form-item label="Email" prop="email">
											<el-input
												v-model="form.email"
												placeholder="Please enter"
												maxlength=""
												clearable
											/>
										</el-form-item>

										<!-- Phone -->
										<el-form-item label="Phone" prop="phone">
											<el-input
												v-model="form.phone"
												placeholder="Please enter"
												maxlength=""
												clearable
											/>
										</el-form-item>

										<!-- Address -->
										<el-form-item label="Address" prop="address">
											<el-input
												type="textarea"
												:rows="2"
												v-model="form.address"
												placeholder="Please enter"
												maxlength=""
												clearable
											/>
										</el-form-item>

										<!-- Buttons -->
										<div class="btn-group">
											<el-button type="primary" @click="handleSave">
												Save
											</el-button>

											<el-button type="primary" @click="handleCancel">
												Cancel
											</el-button>
										</div>
									</el-form>
								</div>
							</div>
						</div>
					</div>
				</el-main>
			</el-container>
		</el-container>

		<!-- Loading -->
		<transition name="fade">
			<div class="loading" v-show="isLoading">
				<van-loading />
			</div>
		</transition>
		<!-- Loading -->
	</div>
</template>

<script>
import { suplierAdd, suplierEdit, suplierDetail } from '@/api/capaManage/configCapa/capaManageSuppliers/index';
import headers from "@/component/header.vue";
import slider from "@/component/slider.vue";
export
default {
	components: {
		headers,
		slider,
	},
	data() {
		return {
			isLoading: true,
			form: {
				title: '',
				description: '',
				name: '',
				email: '',
				phone: '',
				address: ''
			},
			rules: {
				title: [{ required: true, message: "Please enter", trigger: "blur" }],
				// description: [{ required: true, message: "请输入", trigger: "blur" }],
				// name: [{ required: true, message: "请输入", trigger: "blur" }],
				// email: [{ required: true, message: "请输入", trigger: "blur" }],
				// phone: [{ required: true, message: "请输入", trigger: "blur" }],
				// address: [{ required: true, message: "请输入", trigger: "blur" }]
			},
		};
	},
	created() {
		let that = this;
	},
	mounted() {
		let that = this;
		if(that.$route.query.oid) {
			//编辑
			suplierDetail({ id: that.$route.query.oid }).then(res => {
				if(res.code == 200) {
					that.form.id = res.data.id;
					that.form.title = res.data.title;
					that.form.description = res.data.description;
					that.form.name = res.data.name;
					that.form.email = res.data.email;
					that.form.phone = res.data.phone;
					that.form.address = res.data.address;
				}
				that.isLoading = false;
			});
		}else {
			that.isLoading = false;
		}
	},
	watch: {
		//
	},
	methods: {
		handleSave() {
			let that = this;
			that.$refs.form.validate((valid) => {
				if (!valid) return;
				that.$toast.loading({ duration: 0, forbidClick: true });
				if(that.$route.query.oid) {
					// 编辑
					suplierEdit(that.form).then(res => {
						if(res.code == 200) {
							that.$toast.clear();
							that.$message.success("Operation successful");
							setTimeout(() => {
								that.$router.back();
							}, 800);
						}
					});
				}else {
					// 添加
					suplierAdd(that.form).then(res => {
						if(res.code == 200) {
							that.$toast.clear();
							that.$message.success("Operation successful");
							setTimeout(() => {
								that.$router.back();
							}, 800);
						}
					});
				}
			});
		},
		handleCancel() {
			let that = this;
			that.$router.back();
		},
		//跳转页面
		goUrl(url) {
			let that = this;
			that.$router.push(url);
		},
	},
}
</script>

<style lang="less" scoped>
//主要内容
.main_main {
  .page_main {
    padding: 18px 20px;
    .btn_el {
      margin: 10px 0 20px 0;
      .tips {
        padding: 6px 8px;
        background-color: #ffb1001a;
        border-radius: 6px;
        font-size: 16px;
        font-weight: bold;
      }
    }
  }
  //页头
  .page_header {
    padding: 0 20px;
    height: 60px;
    line-height: 60px;
    background-color: #d8e4f0;
    font-size: 24px;
    font-weight: bold;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.075);
  }
}
</style>
<style scoped>
.main_box {
  height: calc(100vh - 60px);
  overflow-y: auto;
}
.main_box .main_main {
  position: relative;
  min-height: calc(100% - 0px);
  max-height: auto;
  background-color: #fafafa;
}
.el-header,
.el-main {
  padding: 0;
}

.training-type-page {
  background: #f5f5f5;
  min-height: 100vh;
  padding: 14px;
  box-sizing: border-box;
}

.training-form {
  width: 100%;
}

.tip-box,
.info-box {
  background: #f5efe4;
  border-radius: 6px;
  padding: 14px 16px;
  color: #333;
  line-height: 1.8;
  margin-bottom: 18px;
  box-sizing: border-box;
}

.tip-box {
  font-size: 15px;
}

.info-box .info-text {
  font-size: 15px;
  font-weight: 500;
  margin-bottom: 4px;
}

.info-box ul {
  margin: 6px 0 0 20px;
  padding: 0;
}

.info-box li {
  margin: 2px 0;
}

::v-deep .el-form-item__label {
  font-size: 16px;
  color: #222;
  font-weight: 600;
  padding-bottom: 8px;
}

::v-deep .el-input__inner,
::v-deep .el-select .el-input__inner {
  height: 42px;
  line-height: 42px;
  border-radius: 6px;
  font-size: 14px;
}

.btn-group {
  margin-top: 32px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 12px;
}

.btn-group .el-button {
  min-width: 88px;
  height: 48px;
  font-size: 16px;
  border-radius: 8px;
  padding: 0 24px;
}

::v-deep .btn span {
  text-decoration: underline;
}
</style>

